export default __webpack_public_path__ + "assets/images/b788b23a17ab96bff2a0c7260f01f5a4.png";